import { db } from './db.js';
import { repository, RecordConflictError } from './repository.js';
export async function saveTreatmentResult(input, expectedTreatmentRevision, expectedLogRevision = null, operationId) {
    return db.transaction('rw', [db.treatments, db.treatmentLogs], async () => {
        const resultId = operationId ? `treatment-result:${operationId}` : undefined;
        if (resultId) {
            const previous = await db.treatmentLogs.get(resultId);
            if (previous) {
                const fields = ['petId', 'treatmentId', 'recordedAt', 'scheduledAt', 'status', 'payload'];
                if (previous.deletedAt || previous.duplicateOf || fields.some((key) => JSON.stringify(previous[key] ?? null) !== JSON.stringify(input[key] ?? null)))
                    throw new RecordConflictError(previous);
                return previous;
            }
        }
        const treatment = await db.treatments.get(input.treatmentId);
        if (!treatment || treatment.deletedAt || treatment.petId !== input.petId)
            throw new Error('아이와 투약·처치 원본을 다시 확인해 주세요.');
        if (treatment.updatedAt !== expectedTreatmentRevision)
            throw new RecordConflictError(treatment);
        const current = typeof input.scheduledAt === 'number' ? (await db.treatmentLogs.where('[treatmentId+scheduledAt]').equals([input.treatmentId, input.scheduledAt]).toArray()).find((row) => !row.deletedAt && !row.duplicateOf) : undefined;
        if (current && current.updatedAt !== expectedLogRevision)
            throw new RecordConflictError(current);
        return repository.put('treatmentLogs', { ...input, ...(resultId ? { id: resultId } : {}), ...(current ? { id: current.id, createdAt: current.createdAt, updatedAt: current.updatedAt } : {}) });
    });
}
